<script lang="ts">
    import DBG from "../code/DBG";
    import Button from "./Generic/Button.svelte";
    import ContactSupport from "./Generic/ContactSupport.svelte";
    function openDialog() {
        DBG.log("UnauthPage - openDialog, windows location", window.location);
        Office.context.ui.displayDialogAsync(
            window.location.origin + "/startauth",
            (result) => {
                DBG.log("UnauthPage - display dialog result:", result);
                result.value.addEventHandler(
                    Office.EventType.DialogMessageReceived,
                    (args) => {
                        DBG.log("UnauthPage - DialogMessageReceived:", args);

                        result.value.close();
                        window.location.reload();
                    }
                );
                result.value.addEventHandler(
                    Office.EventType.DialogEventReceived,
                    (args) => {
                        DBG.log("UnauthPage - DialogEventReceived:", args);
                        result.value.close();
                    }
                );
                result.value.addEventHandler(
                    Office.EventType.DialogParentMessageReceived,
                    (args) => {
                        DBG.log(
                            "UnauthPage - DialogParentMessageReceived:",
                            args
                        );
                        result.value.close();
                    }
                );
            }
        );
    }

    function openAuthDialog() {
        DBG.log("UnauthPage - openAuthDialog");
        /*openDialog();  -> this was used for AAD login */
        window.location.href = "/signin";
    }
</script>

<div class="row" id="unauth-main">
    <div class="col-md-6">
        <img
            src="img/logo.png"
            alt="Time-location add-in for Microsoft Project"
        />
        <p>
            To use the Time-location Microsoft Project add-in, you must log in
            with your <strong>email</strong> and the registered
            <strong>password</strong>.
        </p>

        <div class="button-holder" />
        <Button
            Text="Log in"
            Icon="fas fa-sign-in-alt"
            on:click={openAuthDialog}
        />

        <hr />
        <p>Having trouble logging in?</p>
        <p>
            <i class="fa fa-envelope" />
            <ContactSupport />
        </p>
        <hr />
        <p class="mt-3">Interested in buying the TLMSP addin?</p>
        <p>
            <i class="fa fa-file-contract" />
            <a href="https://tlmsp.com" target="_blank">Use this form</a>
        </p>
    </div>
</div>

<style>
    #unauth-main {
        display: flex;
        justify-content: center;
        align-items: center;      
        padding: 1rem;
    }

    #unauth-main img {
        width: 100%;
        margin-top: 1rem;
        margin-bottom: 1rem;
    }
 
    .button-holder {
        display: flex;
        justify-content: center;
    }
</style>
